import { Link } from 'react-router-dom';
import { latestNews } from '@/mocks/home';

export default function LatestNews() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="container-custom">
        <div className="flex items-end justify-between mb-10 md:mb-14">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-2">
              最新资讯
            </h2>
            <p className="text-foreground-500 text-sm md:text-base">掌握体育圈最新动态，深度解读赛事热点</p>
          </div>
          <Link
            to="/category/football"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {latestNews.slice(0, 6).map((news, index) => (
            <Link
              key={news.id}
              to={`/article/${news.id}`}
              className={`group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer ${
                index === 0 ? 'lg:col-span-2 lg:row-span-2' : ''
              }`}
            >
              <div className={`relative overflow-hidden ${index === 0 ? 'h-48 md:h-64' : 'h-40 md:h-48'}`}>
                <img
                  src={news.image}
                  alt={news.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  title={news.title}
                />
                {news.featured && (
                  <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-semibold whitespace-nowrap">
                    精选
                  </span>
                )}
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-3 mb-2">
                  <span className="text-xs font-medium text-primary-600 bg-primary-100 px-2.5 py-0.5 rounded-full whitespace-nowrap">
                    {news.category}
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{news.date}</span>
                </div>
                <h3 className={`font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2 ${index === 0 ? 'text-lg md:text-xl' : 'text-base'}`}>
                  {news.title}
                </h3>
                <p className={`text-foreground-500 leading-relaxed line-clamp-2 ${index === 0 ? 'text-sm' : 'text-xs'}`}>
                  {news.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 flex justify-center sm:hidden">
          <Link
            to="/category/football"
            className="flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            查看全部资讯 <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}